// import * as http from './http';
import ApiService from './service';
import * as http from './http';
import { stringify } from 'query-string';

export class SharePointService extends ApiService {
    async addDetails(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.post(url, data, this.store);
    }

    async getDetails(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async updateRecord(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.put(url, data, this.store);
    }

    async softDeleteRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const data = {};
        return http.patch(url, data, this.store);
    }

    async deleteRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const data = {};
        return http.remove(url, data, this.store);
    }

    async downloadFile(request) {
        const { documentCategory, fileName, folderName, type } = request.data;
        const query = {
            documentCategory, fileName, folderName, type
        };

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .download(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async fetchImageUrls(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.post(url, data, this.store);
    }

    async fetchGalleryImages(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.get(url, this.store);
    }

}
